// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1haiz{margin-left:50%;-webkit-transform:translate3d(-50%,0,0);transform:translate3d(-50%,0,0);margin-bottom:4rem;margin-top:1.25rem;text-align:center}@media(max-width:767px){._1haiz{margin-top:6.75rem}}._2XKA9{padding:1.5rem 1rem;background:#fff;border:none;border-radius:100px;-webkit-box-shadow:0 4px 32px rgba(148,196,254,.08);box-shadow:0 4px 32px rgba(148,196,254,.08)}._3bcft{margin-top:.75rem;color:#0373f9;font-size:16px;font-size:1rem;font-weight:500;line-height:20px;line-height:1.25rem;font-family:var(--heading-font);letter-spacing:var(--letter-spacing)}", ""]);
// Exports
exports.locals = {
	"root": "_1haiz",
	"button": "_2XKA9",
	"text": "_3bcft"
};
module.exports = exports;
